export default __webpack_public_path__ + "static/media/ReglasX+YImagenes-Practicas-y-Consultas.52b6af98.pdf";